import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";
import salaryPerMonthFormMeta, { ISalaryPerMonthFormMeta } from "./salaryFormMeta";

export interface IProfessionalInformationFormMeta extends ISalaryPerMonthFormMeta {
  // Professional Information
  employeeCode: FormInputMeta;
  employerName: FormInputMeta;

  grade: FormInputMeta;
  since: FormInputMeta;
}

let professionalInformationFormMeta = {} as IProfessionalInformationFormMeta;

// Professional information

professionalInformationFormMeta.employeeCode = {
  name: "employeeCode",
  type: "text",
  label: "Code Employé",
  placeholder: "",
  validation: yup.string()
};
  
professionalInformationFormMeta.employerName = {
  name: "employerName",
  type: "text",
  label: "Nom Employeur",
  placeholder: "",
  validation: yup.string(),
};
    
professionalInformationFormMeta.grade = {
  name: "grade",
  type: "select",
  label: "Position Ou Titre",
  placeholder: "",
  validation: yup.string(),
};
  
professionalInformationFormMeta.since = {
  name: "since",
  type: "date",
  label: "Depuis",
  placeholder: "",
  validation: yup.string(),
};

professionalInformationFormMeta = { ...professionalInformationFormMeta, ...salaryPerMonthFormMeta }
  
export default professionalInformationFormMeta;